import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import styled, { keyframes, css } from 'styled-components';

const spin = keyframes`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`;

export const AutoSaveContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: center;
	padding: 0.5rem;
`;

export const SpinningIcon = styled(Icon)<{ $isSpinning: boolean }>`
	${({ $isSpinning }) =>
		$isSpinning &&
		css`
			animation: ${spin} 1500ms infinite linear;
		`}
`;
